import { currency } from '../utils';

export function PriceSlider({ min, max, value, onChange }) {

    function handleSliderChange(e) {
      onChange(e.target.value);
    }

    return(
      <div className="rentals-section__slider-container">
        <div className="rentals-section__slider-amount">{ currency(value) }</div>
        <input className="rentals-section__slider" type="range" min={min} max={max} value={ value } onChange={handleSliderChange} />
        <div className="rentals-section__slider-wrapper">
          <div className="text-center">{ currency(min) }</div>
          <div className="text-right">{ currency(max) }</div>
        </div>
      </div>
    );
}